import { type ReactNode } from 'react'

export interface FirmDashboardJobsViewerHeaderProps {
  primaryControls: ReactNode
  filterControls: ReactNode
}

export function FirmDashboardJobsViewerHeader({
  primaryControls,
  filterControls,
}: FirmDashboardJobsViewerHeaderProps) {
  return (
    <div>
      {primaryControls}
      {filterControls}
    </div>
  )
}
